import router from '@/router'
import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import { useGlobalStore } from '@/stores/global'
import lookups from '@/assets/json/clientLookups.json'

export default function () {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const globalStore = useGlobalStore()
  const { ServiceTransactions, transactionReason } = lookups

  const showIssueNewLeavePermitOption =
    router.currentRoute.value.params.serviceId == ServiceTransactions.cancelLeavePermit &&
    formStore.form.values.transactionReasonId == transactionReason.leavePermitIsExpired
  const res = {
    selectIdentificater: formStore.form.values.selectIdentificater,
    showPersonalInformation: formStore.extraMap.showPersonalInformation,
    isInCompleteDraftFlag: formStore.extraMap.isInCompleteDraftFlag,
    enableCreateNewLeavePermitWhenCancelation:
      globalStore.startedService.enableCreateNewLeavePermitWhenCancelation,
    showIssueNewLeavePermitOption,
    issueNewLeavePermit: showIssueNewLeavePermitOption && formStore.extraMap.issueNewLeavePermit,
    isGuestUser: authStore.isGuestUser,
    showSponsorInformation: formStore.extraMap.showSponsorInformation,
    isSponsorIdentityNumber: formStore.extraMap.isSponsorIdentityNumber || false
  }
  return res
}
